import { useUserContext } from '@/context/UserContext';
import { WebshopProduct } from '@/modules/apiTypes';
import { useMemo } from 'react';

interface StockStatusProps {
  stockStatus: WebshopProduct['stock_status'];
  stockStatusDisplayStrings?: {
    not_in_stock: string;
    low_in_stock: string;
    in_stock: string;
  };
  className?: string;
}

export default function StockStatus({
  stockStatus,
  stockStatusDisplayStrings = {
    not_in_stock: 'Finns ej i lager',
    low_in_stock: 'Få i lager',
    in_stock: 'Finns i lager',
  },
  className,
}: StockStatusProps) {
  const { selectedCustomer } = useUserContext();

  const iconColor = useMemo(() => {
    switch (stockStatus) {
      case 'in_stock':
        return 'bg-custom-green';
      case 'low_in_stock':
        return 'bg-custom-yellow';
      case 'not_in_stock':
        return 'bg-custom-red';
      default:
        return '';
    }
  }, [stockStatus]);

  if (stockStatus === undefined || !selectedCustomer?.price_class) {
    return null;
  }

  const displayString = stockStatusDisplayStrings[stockStatus];
  return (
    <div className={`flex flex-row items-center ${className ?? ''}`}>
      <div className={`mr-1 h-3 w-3 rounded-full ${iconColor}`} />
      <div className="whitespace-nowrap text-sm text-custom-darkgrey opacity-75">
        {displayString}
      </div>
    </div>
  );
}
